module.exports = __webpack_public_path__ + "media/images/flags/bo-3c25f404c1260f4b3c9fcdff2d2d8ba5.svg";